import React, { useEffect } from "react";
import { Grid, Card, Switch, Tooltip } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const VehicleCheckerPermissionCard = (props) => {
  const { modules, setModules } = props;
  useEffect(() => {
    if (modules.Vehicle_checker_view === undefined) {
      setModules((prevModules) => ({
        ...prevModules,
        Vehicle_checker_view: true,
      }));
    }
  }, [modules, setModules]);

  const handleVehicleCheckerViewChange = (event) => {
    const isVehicleCheckerViewEnabled = event.target.checked;
    setModules({
      ...modules,
      Vehicle_checker_view: isVehicleCheckerViewEnabled,
    });
  };

  return (
    <>
      <Card sx={{ minWidth: 275, boxShadow: 3 }}>
        <MDBox p={2}>
          <Grid container spacing={1}>
            <Grid item lg={12} md={12} xs={12} container alignItems="center">
              <MDTypography
                color="dark"
                display="block"
                variant="subtitle2"
                fontWeight="bold"
                sx={{ flex: 1 }}
              >
                Vehicle Checker Module
              </MDTypography>

              <Tooltip
                title={`${
                  modules.Vehicle_checker_view ? "Disable" : "Enable"
                } Vehicle Checker module`}
                placement="top"
              >
                <Switch
                  checked={modules.Vehicle_checker_view}
                  onChange={handleVehicleCheckerViewChange}
                />
              </Tooltip>
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    </>
  );
};

export default VehicleCheckerPermissionCard;
